import {
  FETCH_LAYOUT_DATA,
  FETCH_LAYOUT_DATA_ERROR,
  FETCH_LAYOUT_DATA_LOADING
} from "../constants";
import client from "../apolloClient";
import gql from "graphql-tag";

export function layoutDataFetchData(fetchQuery) {
  return dispatch => {
    dispatch(layoutDataIsLoading(true));
    let query;

    if (fetchQuery) {
      query = fetchQuery;
    } else {
      query = gql`
        {
          simcaa_t_layouts {
            id
            layout_name
            layout_mode
            layout_margins
            width
            height
          }
        }
      `;
    }

    client
      .query({ query })
      .then(data => {
        dispatch(layoutDataIsLoading(false));
        if (data.networkStatus !== 7) {
          dispatch(layoutDataHasErrored(true));
        } else {
          dispatch(layoutDataFetchDataSuccess(data.data.simcaa_t_layouts));
          dispatch(layoutDataHasErrored(false));
        }
      })
      .catch(error => {
        dispatch(layoutDataIsLoading(false));
        dispatch(layoutDataHasErrored(true));
      });
  };
}

export function layoutDataHasErrored(bool) {
  return {
    type: FETCH_LAYOUT_DATA_ERROR,
    hasErrored: bool
  };
}

export function layoutDataIsLoading(bool) {
  return {
    type: FETCH_LAYOUT_DATA_LOADING,
    isLoading: bool
  };
}

export function layoutDataFetchDataSuccess(layoutData) {
  return {
    type: FETCH_LAYOUT_DATA,
    layout: layoutData
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/LayoutFetchActions.js